<template>
  <FormSection
    :title="$t('form.invoiceForm.headers.settings')"
    :description="getTranslation('form.invoiceForm.headers.settings_description')"
    :image="require('~/images/ico-settings.svg')"
    id="form-general-settings"
    class="general-settings el-form-item--lg"
    :class="{ 'content-hidden' : !showSettings }"
    has-big-image
  >
    <Anchor
      @click="toggle"
      class="toggle-link"
      slot="control"
      data-test="toggle_general_settings"
    >
      {{ $t(`form.invoiceForm.${showSettings ? 'hide' : 'show'}Settings`) }}
      <i :class="`toggle-icon el-icon-view el-icon-arrow-${showSettings ? 'up' : 'down'}`" />
    </Anchor>

    <CollapseTransition>
      <div v-show="showSettings">
        <InvoiceSettings />
      </div>
    </CollapseTransition>
  </FormSection>
</template>

<script>
import Cookies from 'js-cookie';
import { mapState, mapGetters } from 'vuex';
import InvoiceSettings from './InvoiceSettings.vue';

export default {
  name: 'GeneralSettings',
  components: {
    InvoiceSettings,
  },
  data: () => ({
    showSettings: false,
  }),
  computed: {
    ...mapGetters('invoiceForm', ['visibilities']),
    ...mapState('config', {
      hideGlobalSettings: state => state.subscription['hide_global_settings?'],
    }),
    ...mapGetters('auth', ['isAuthorized']),
    isMobileDevice() {
      return window.innerWidth <= 768;
    },
  },
  methods: {
    toggle() {
      this.showSettings = !this.showSettings;
      Cookies.set('showGlobalSettings', this.showSettings);
    },
    getTranslation(key) {
      const translation = this.$t(key);
      return translation !== key ? translation : '';
    },
  },
  created() {
    const unwatchHideGlobalSettings = this.$watch(
      'hideGlobalSettings',
      (newVal) => {
        const settingFromBackend = !newVal;
        const showGlobalFromCookie = Cookies.get('showGlobalSettings');

        // Early return if showGlobalFromCookie is defined and user is authorized
        if (typeof showGlobalFromCookie !== 'undefined' && this.isAuthorized) {
          this.showSettings = showGlobalFromCookie === 'true';
          unwatchHideGlobalSettings?.();
          return;
        }

        // Early return if !newVal and !this.isAuthorized and onFeatureFlags is undefined
        if (!newVal && !this.isAuthorized) {
          if (typeof this.$posthog?.onFeatureFlags === 'undefined') {
            this.showSettings = true;
            unwatchHideGlobalSettings?.();
            return;
          }

          // Use onFeatureFlags if it is defined
          this.$posthog?.onFeatureFlags(() => {
            this.showSettings = this.$posthog?.getFeatureFlag('general-settings-toggle') !== 'test';
          });
          unwatchHideGlobalSettings?.();
          return;
        }

        // Default case: set showSettings based on settingFromBackend
        this.showSettings = settingFromBackend;
        unwatchHideGlobalSettings?.();
      },
      { immediate: true },
    );
  },
  mounted() {
    if (typeof this.$route.hash !== 'undefined') {
      if (this.$route.hash === '#showGeneralSettings') {
        this.showSettings = true;

        this.$store.dispatch('uiEffects/scrollToElement', document.getElementById('form-general-settings'));
      }
    }
    if (this.isMobileDevice) {
      this.showSettings = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.toggle-link {
  font-weight: 600;
  font-size: rem(14px);
  text-decoration: underline;

  .toggle-icon {
    font-weight: 700;
    vertical-align: middle;
  }
}

.content-hidden {
  :deep() {
    .new-form-header {
      margin-bottom: 0;
      transition: margin-bottom .5s ease;
    }
  }
}
</style>
